"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _BoundingRectObserver_instances, _BoundingRectObserver_dispatch, _BoundingRectObserver_startIntersectionObserver, _BoundingRectObserver_stopIntersectionObserver, _BoundingRectObserver_startScrollObserver, _BoundingRectObserver_stopScrollObserver, _BoundingRectObserver_onScroll, _BoundingRectObserver_startResizeObserver, _BoundingRectObserver_stopResizeObserver, _BoundingRectObserver_onResize, _BoundingRectObserver_startWindowResizeObserver, _BoundingRectObserver_stopWindowResizeObserver, _BoundingRectObserver_onWindowResize;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundingRectObserver = exports.EVENT_CHANGE = void 0;
const lodash_throttle_1 = __importDefault(require("lodash.throttle"));
exports.EVENT_CHANGE = "change";
/**
 * 要素の表示位置を検知
 * 画面内に表示されたときやリサイズされたときにイベントを通知する
 */
class BoundingRectObserver extends EventTarget {
    constructor(el) {
        // EventTargetを敬称しているのでこの記述が必要
        super();
        _BoundingRectObserver_instances.add(this);
        // 画面内に表示されているか
        this.isIntersecting = false;
        // ResizeObserverを検知中
        this.isResizeObserverActive = false;
        this.el = el;
        // 画面への登場を検知する
        this.intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                // 1ピクセルでも表示されていたら表示されていると判定
                this.isIntersecting = entry.intersectionRect.height > 0;
                if (this.isIntersecting) {
                    // 画面内に表示されたら、重なりを判定するためにスクロール＆リサイズイベントを登録する
                    __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_startResizeObserver).call(this);
                    __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_startScrollObserver).call(this);
                    __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_startWindowResizeObserver).call(this);
                }
                else {
                    __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_stopResizeObserver).call(this);
                    __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_stopScrollObserver).call(this);
                    __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_stopWindowResizeObserver).call(this);
                }
            });
        }, {
            threshold: Array.from({ length: 101 }, (_, i) => i / 100) // 0〜1まで1％ずつ。1pxで判定したいのでできるだけ細かく指定する。
        });
        // リサイズを検知する
        this.resizeObserver = new ResizeObserver(() => {
            this.throttledResizeHandler();
        });
        // thisの移譲とremoveEventListenerができるようにハンドラーを登録しておく
        this.throttledScrollHandler = (0, lodash_throttle_1.default)(__classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_onScroll).bind(this), 200);
        this.throttledResizeHandler = (0, lodash_throttle_1.default)(__classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_onResize).bind(this), 200);
        this.throttledWindowResizeHandler = (0, lodash_throttle_1.default)(__classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_onWindowResize).bind(this), 200);
        // 通知時のイベント
        // 引数を渡すのでカスタムイベントにする
        this.eventForDispatch = new CustomEvent(exports.EVENT_CHANGE, {
            detail: {
                el: this.el
            }
        });
        __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_startIntersectionObserver).call(this);
    }
    /**
     * 監視を開始
     */
    start() {
        // 画面内への表示を起点にするので、intersectionObserverだけ実行する。
        __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_startIntersectionObserver).call(this);
    }
    /**
     * 監視を終了
     */
    stop() {
        // 終了時はすべてのオブザーバーを停止
        __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_stopIntersectionObserver).call(this);
        __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_stopResizeObserver).call(this);
        __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_stopScrollObserver).call(this);
    }
    destroy() {
        // 停止のエイリアス
        this.stop();
    }
}
exports.BoundingRectObserver = BoundingRectObserver;
_BoundingRectObserver_instances = new WeakSet(), _BoundingRectObserver_dispatch = function _BoundingRectObserver_dispatch() {
    this.dispatchEvent(this.eventForDispatch);
}, _BoundingRectObserver_startIntersectionObserver = function _BoundingRectObserver_startIntersectionObserver() {
    this.intersectionObserver.observe(this.el);
}, _BoundingRectObserver_stopIntersectionObserver = function _BoundingRectObserver_stopIntersectionObserver() {
    this.intersectionObserver.unobserve(this.el);
}, _BoundingRectObserver_startScrollObserver = function _BoundingRectObserver_startScrollObserver() {
    window.addEventListener("scroll", this.throttledScrollHandler);
}, _BoundingRectObserver_stopScrollObserver = function _BoundingRectObserver_stopScrollObserver() {
    window.removeEventListener("scroll", this.throttledScrollHandler);
}, _BoundingRectObserver_onScroll = function _BoundingRectObserver_onScroll() {
    __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_dispatch).call(this);
}, _BoundingRectObserver_startResizeObserver = function _BoundingRectObserver_startResizeObserver() {
    if (!this.isResizeObserverActive) {
        this.resizeObserver.observe(this.el);
        this.isResizeObserverActive = true;
    }
}, _BoundingRectObserver_stopResizeObserver = function _BoundingRectObserver_stopResizeObserver() {
    this.resizeObserver.unobserve(this.el);
    this.isResizeObserverActive = false;
}, _BoundingRectObserver_onResize = function _BoundingRectObserver_onResize() {
    __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_dispatch).call(this);
}, _BoundingRectObserver_startWindowResizeObserver = function _BoundingRectObserver_startWindowResizeObserver() {
    window.addEventListener("resize", this.throttledWindowResizeHandler);
}, _BoundingRectObserver_stopWindowResizeObserver = function _BoundingRectObserver_stopWindowResizeObserver() {
    window.removeEventListener("resize", this.throttledWindowResizeHandler);
}, _BoundingRectObserver_onWindowResize = function _BoundingRectObserver_onWindowResize() {
    __classPrivateFieldGet(this, _BoundingRectObserver_instances, "m", _BoundingRectObserver_dispatch).call(this);
};
